import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControlKeyRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"control-key-right"} maskId="square-filled-radius-0-stroke-1-IconControlKeyRight"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM14 6.79289L10.7929 10L11.5 10.7071L14 8.20711L16.5 10.7071L17.2071 10L14 6.79289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconControlKeyRight;
